/**
 * An Expo Router error boundary for a screen. It renders a fallback inside the
 * navigator in place of a screen that throws, so the header and tab bar stay
 * mounted.
 *
 * The fallback reports the error to Sentry and shows its message.
 */

import { useTheme } from '@repo/theme';
import { Center, Pad } from 'component/basics';
import { UtilityText } from 'component/text';
import type { ErrorBoundaryProps } from 'expo-router';
import { useEffect } from 'react';
import { captureException } from 'util/sentry';
import { t } from 'util/stdtypes';

export function ScreenErrorBoundary({ error }: ErrorBoundaryProps) {
    const { colors } = useTheme();

    useEffect(() => {
        captureException(error);
    }, [error]);

    return (
        <Center pad={20}>
            <UtilityText label={t('error.api', 'Something went wrong')} type='large' />
            <Pad size={8} />
            <UtilityText color={colors.colorTextSecondary} text={error.message} />
        </Center>
    );
}
